import { useState, useEffect, useContext } from "react";
import { Switch, Typography, Space } from "antd";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/AuthContext";
import { useTranslation } from "react-i18next";
import { useGlobalToast } from "../../context/ToastProvider";
import { getFleetDetails, updateFleetDetails } from "../../services/fleetDetailsFirestore";
import { getBillingOverview } from "../../services/billingService";

export default function EDocSwitchButton({ fleetId: fleetIdProp }) {
  const { getFleetID } = useContext(AuthContext);
  const fleetId = fleetIdProp || getFleetID();
  const [isEnabled, setIsEnabled] = useState(false);
  const [billingEntitled, setBillingEntitled] = useState(false);
  const [loading, setLoading] = useState(false);
  const toast = useGlobalToast();
  const { t } = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    const fetchState = async () => {
      try {
        const [details, billing] = await Promise.all([
          getFleetDetails(fleetId),
          getBillingOverview(fleetId),
        ]);
        setIsEnabled(details?.useEDOCs ?? false);
        setBillingEntitled(Boolean(billing?.entitlements?.etdEnabled));
      } catch (error) {
        console.error("Error al obtener estado de useEDOCs:", error);
      }
    };

    if (fleetId) {
      fetchState();
    }
  }, [fleetId]);

  const handleToggle = async () => {
    const newValue = !isEnabled;
    if (newValue && !billingEntitled) {
      toast({
        title: t("setup.eDocsBillingRequired"),
        status: "warning",
      });
      navigate("/billing");
      return;
    }
    setLoading(true);
    try {
      await updateFleetDetails(fleetId, { useEDOCs: newValue });

      setIsEnabled(newValue);

      toast({
        title: newValue
          ? t("setup.eDocsEnabled") || "e-Docs activado"
          : t("setup.eDocsDisabled") || "e-Docs desactivado",
        status: "success",
      });
    } catch (error) {
      console.error("Error al actualizar useEDOCs:", error);
      toast({ error,
        title: t("setup.eDocsUpdateError"),
        status: "warning",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Space direction="vertical" style={{ marginTop: 12 }}>
      <Space align="center">
        <Typography.Text>{t("setup.useEDocs") || "Usar e-Docs"}</Typography.Text>
        <Switch checked={isEnabled} onChange={handleToggle} disabled={loading || (!billingEntitled && !isEnabled)} />
      </Space>
      {!billingEntitled ? (
        <Typography.Text type="secondary">
          {t("setup.eDocsBillingRequired")}
        </Typography.Text>
      ) : null}
    </Space>
  );
}
